import React from "react";
import { MoonLoader } from "react-spinners";
import { FadeLoader } from "react-spinners";
import { HashLoader } from "react-spinners";
import { ScaleLoader } from "react-spinners";

const Spinner = ({ size, color }) => {
  return (
    <div
      tabIndex="0"
      onKeyDown={(e) => e.preventDefault()}
      onKeyUp={(e) => e.preventDefault()}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.6)", // Translucent backgroundColor
        zIndex: 9999, // Place it on top of other content
      }}
    >
      <FadeLoader size={size} color={color} speedMultiplier={1} />
    </div>
  );
};

export default Spinner;
